/**
 * Helpers for user-supplied values that reach PostgREST `like` / `ilike`.
 *
 * In SQL LIKE, `_` matches any single character and `%` any run, with `\` as
 * the escape character — so `.ilike('username', 'john_smith')` also matched
 * `john-smith`. PostgREST additionally rewrites every `*` in a like/ilike
 * value to `%` and offers NO escape for it. Escaping therefore handles `_ % \`
 * and identifiers must be VALIDATED (isLookupSafe) before they are queried.
 */
export function escapeLike(value: string): string {
  return value.replace(/[\\%_]/g, (c) => `\\${c}`);
}

/** A username, slug or UUID — the only shapes worth sending to an ILIKE lookup. */
export const LOOKUP_SAFE_RE = /^[A-Za-z0-9][A-Za-z0-9_.-]{0,63}$/;
export function isLookupSafe(value: string): boolean {
  return LOOKUP_SAFE_RE.test(value);
}

/**
 * Quote a value for use inside a PostgREST `.or()` filter string, where
 * commas, parentheses and dots are syntax. Backslashes and double quotes are
 * escaped; a LIKE-escaped value (from escapeLike) survives the round trip.
 */
export function orValue(value: string): string {
  return `"${value.replace(/[\\"]/g, (c) => `\\${c}`)}"`;
}
